import React, { useState, useEffect, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useForm, Controller, useFieldArray, useFormContext } from "react-hook-form";
import axios from "axios";
import moment from "moment";
import Swal from "sweetalert2";
import { Container, Paper, Title, Divider, Grid, Button, Group, Text, Stack, Input, Checkbox, TextInput } from '@mantine/core';
import { PaymentInputsWrapper, usePaymentInputs } from "react-payment-inputs";
import images from "react-payment-inputs/images";
import { CountryDropdown, RegionDropdown } from "react-country-region-selector";
import { FiUser, FiMail, FiPhone, FiCreditCard, FiDollarSign, FiCalendar, FiClock, FiHome, FiMinusCircle, FiMinus } from 'react-icons/fi';

import { RHFTextInput, RHFSelect, RHFCheckbox, RHFTextarea, RHFGoogleAddress, RHFCustomDatePicker, RHFNumberInput } from "./FormComponents";
import './enrollment.css'
import base_url from "../../api/bootapi";
import Nav from "../NavBar/Nav";
import FooterNew from "../NavBar/FooterNew";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";



// Reusable inline style for the country/region selects to match Mantine's inputs
const selectStyle = {
    width: '100%',
    height: '40px',
    padding: '0 12px',
    borderRadius: '4px',
    border: '1px solid #ced4da',
    fontSize: '14px',
    backgroundColor: '#fff',
    fontFamily: 'inherit'
};

const ticketOptions = [
    { label: "First", value: "First" },
    { label: "Business", value: "Business" },
    { label: "Premium", value: "Premium" },
    { label: "Economy Class (Cost will be advised)", value: "Economy Class" }
];


    const CustomerForm = ({
  index,
  remove,
  tourDetails,
  address,
        setAddress,
  paymentMethod
}) => {
  const {
    control,
    watch,
    setValue,
    formState: { errors },
        } = useFormContext();

        const minimumDepositRequired =
  tourDetails?.minimum_deposit_mandatory || false;

       const options = watch(`customers.${index}.options`);



const selectedCountry = watch(
  `customers.${index}.country`
);

const depositRequired = watch(
  `customers.${index}.depositRequired`
);

const enableExtraDeposit = watch(
  `customers.${index}.enableExtraDeposit`
);
        
        const customerAddress = watch(
  `customers.${index}.address`
        );
        

        useEffect(() => {
  const subscription = watch((value, { name }) => {
    const customer = value?.customers?.[index];

    if (
      name === `customers.${index}.options.fullPackage` &&
      customer?.options?.fullPackage
    ) {
      setValue(
        `customers.${index}.options.accommodation`,
        false
      );
    }

    if (
      name === `customers.${index}.options.accommodation` &&
      customer?.options?.accommodation
    ) {
      setValue(
        `customers.${index}.options.fullPackage`,
        false
      );
    }

    if (
      name === `customers.${index}.enableExtraDeposit` &&
      !customer?.enableExtraDeposit
    ) {
      setValue(
        `customers.${index}.extraDepositAmount`,
        ""
      );
    }
  });

  return () => subscription.unsubscribe();
}, [watch, setValue, index]);

      
        
         const parseAddressComponents = (components = []) => {
                const result = { city: "", state: "", postalCode: "", country: "" };
                components.forEach((c) => {
                    if (c.types.includes("locality") || (!result.city && c.types.includes("sublocality_level_1")) || (!result.city && c.types.includes("administrative_area_level_2"))) {
                        result.city = c.long_name;
                    }
                    if (c.types.includes("administrative_area_level_1")) result.state = c.long_name;
                    if (c.types.includes("postal_code")) result.postalCode = c.long_name;
                    if (c.types.includes("country")) result.country = c.long_name;
                });
                return result;
            };
        
            const onPlaceSelect_JS = (val, main = true) => {
                if (!val) {
                    if (main) { setValue(`customers.${index}.city`, ""); setValue(`customers.${index}.zip`, ""); setValue(`customers.${index}.state`, ""); setValue(`customers.${index}.country`, ""); }
                    else { setValue(`customers.${index}.billing.city`, ""); setValue(`customers.${index}.billing.zip`, ""); setValue(`customers.${index}.billing.state`, ""); setValue(`customers.${index}.billing.country`, ""); }
                    return;
                }
                let placeId = typeof val === 'object' ? val.value : val;
                if (!window.google || !placeId) return;
        
                const ps = new window.google.maps.places.PlacesService(document.createElement("div"));
                ps.getDetails({ placeId, fields: ["address_components"] }, (place, status) => {
                    if (status === window.google.maps.places.PlacesServiceStatus.OK && place) {
                        const parsed = parseAddressComponents(place.address_components || []);
                        if (main) {
                            setValue(`customers.${index}.city`, parsed.city || ""); setValue(`customers.${index}.zip`, parsed.postalCode || "");
                            setValue(`customers.${index}.state`, parsed.state || ""); setValue(`customers.${index}.country`, parsed.country || "United States");
                        } else {
                            setValue(`customers.${index}.billing.city`, parsed.city || ""); setValue(`customers.${index}.billing.zip`, parsed.postalCode || "");
                            setValue(`customers.${index}.billing.state`, parsed.state || ""); setValue(`customers.${index}.billing.country`, parsed.country || "United States");
                        }
                    }
                });
        };
        
        useEffect(() => {
  onPlaceSelect_JS(customerAddress, true);
}, [customerAddress]);
        
        // useEffect(() => { onPlaceSelect_JS(address1, true); }, [address1]);

        useEffect(() => {
  if (minimumDepositRequired) {
    setValue(
      `customers.${index}.depositRequired`,
      true
    );
  }
}, [minimumDepositRequired]);
        
    const hasCostOptions = options.fullPackage || options.accommodation || options.singleRoomCost || options.insurance;

         const calculateTotal = () => {
        if (!tourDetails) return 0;
        let total = 0;
        if (options.fullPackage) total += Number(tourDetails.full_package_price || 0);
        if (options.accommodation) total += Number(tourDetails.accommodation_only_price || 0);
        if (options.singleRoomCost) total += Number(tourDetails.single_room_cost || 0);
        if (options.insurance) total += Number(tourDetails.insurance_price || 0);
        if (options.otherCost) total += Number(tourDetails.other_cost || 0);
        return total;
    };
        const totalPrice = calculateTotal();
        
        const minimumDeposit = Number(tourDetails?.minimum_deposit || 0);
    

        const sameAsPrevious = watch(
  `customers.${index}.sameAsPrevious`
        );
        

        useEffect(() => {
  if (!sameAsPrevious || index === 0) return;

  const previousCustomer = watch(
    `customers.${index - 1}`
  );

  setValue(
    `customers.${index}.city`,
    previousCustomer?.city || ""
  );

  setValue(
    `customers.${index}.state`,
    previousCustomer?.state || ""
  );

  setValue(
    `customers.${index}.zip`,
    previousCustomer?.zip || ""
  );

  setValue(
    `customers.${index}.country`,
    previousCustomer?.country || ""
            );
            
            setValue(
  `customers.${index}.address`,
  previousCustomer?.address || ""
);

        }, [sameAsPrevious]);
        

  const extraDepositAmount = watch(`customers.${index}.extraDepositAmount`);


        const calculatePaymentDue = () => {
            let due = 0;
            // if (paymentMethod === "Card") {
              if (depositRequired) due += Number(minimumDeposit || 0);
              if (enableExtraDeposit) due += Number(extraDepositAmount || 0);
            // }
            return due;
          };
        
          const paymentDue = calculatePaymentDue();
        
          useEffect(() => {
            setValue(`customers.${index}.advance_payment`, paymentDue);
          }, [paymentDue, setValue]);

        
  return (
    <div >
          
          <Group justify="space-between" align="center" mt="xl">
              

              <Title order={2} >Traveler {index + 1}</Title>
              
              {index > 0 && <button onClick={()=>remove(index)} style={{background:'transparent',padding:'5px', width:'30px',height:'30px',borderRadius:'50%',border:'1.5px solid red',display:'flex',alignItems:'center',justifyContent:'center'}}>
                  <FiMinus size={16} color="red"/>
              </button>}
              
           </Group>

                                <Title order={4} mt="xl">Personal Details</Title>
                                <Divider my="sm" />
                                <Grid>
                                    <Grid.Col span={{ base: 12, md: 3 }}><RHFTextInput isFirstLetter={true} control={control} name={`customers.${index}.first_name`} label="First Name" withAsterisk leftSection={<FiUser size={16} />} rules={{ required: "Required" }} /></Grid.Col>
                                    <Grid.Col span={{ base: 12, md: 3 }}><RHFTextInput isFirstLetter={true} control={control} name={`customers.${index}.middle_name`} label="Middle Name" /></Grid.Col>
                                    <Grid.Col span={{ base: 12, md: 3 }}><RHFTextInput isFirstLetter={true} control={control} name={`customers.${index}.last_name`} label="Last Name" withAsterisk leftSection={<FiUser size={16} />} rules={{ required: "Required" }} /></Grid.Col>
                                    <Grid.Col span={{ base: 12, md: 3 }}><RHFSelect control={control} name={`customers.${index}.gender`} label="Gender" onKeyDown={(e) => {
                                        const key = e.key.toLowerCase();

                                        if (key === 'm') {
                                            setValue(`customers.${index}.gender`, 'Male');
                                        } else if (key === 'f') {
                                            setValue(`customers.${index}.gender`, 'Female');
                                        } else if (key === 'o') {
                                            setValue(`customers.${index}.gender`, 'Other');
                                        }
                                    }} withAsterisk data={["Male", "Female", "Other"]} rules={{ required: "Required" }} /></Grid.Col>

                                    <Grid.Col span={{ base: 12, md: 3 }}>
                                        <Input.Wrapper label="Date of Birth">
                                            <Controller name={`customers.${index}.date_of_birth`} control={control} render={({ field }) => (
                                                <RHFCustomDatePicker value={field.value ?? ''} onChange={(val) => field.onChange(val)} />
                                            )} />
                                        </Input.Wrapper>
              </Grid.Col>
              {
                  index === 0 && <>
                  <Grid.Col span={{ base: 12, md: 3 }}>
                      <RHFNumberInput
                          name={`customers.${index}.mobile_number`}

                          control={control}
                          label="Mobile Number"
                          maxLength={10}
                          rules={{
                              required: "Mobile number is required",
                              validate: (value) =>
                                  value?.length === 10 || "Mobile number must be 10 digits",
                          }}
                          withAsterisk leftSection={<FiPhone size={16} />}
                      />

                  </Grid.Col>
              
              
              
                 <Grid.Col span={{ base: 12, md: 3 }}><RHFTextInput control={control} name={`customers.${index}.email_address`} label="Email" withAsterisk leftSection={<FiMail size={16} />} rules={{ required: "Required" }} /></Grid.Col>
                </>
              }
                                    <Grid.Col span={{ base: 12, md: 3 }}><RHFTextInput control={control} name={`customers.${index}.passport_number`} label="Passport Number" /></Grid.Col>

                                    <Grid.Col span={{ base: 12, md: 3 }}>
                                        <Input.Wrapper label="Passport Expiration">
                                            <Controller name={`customers.${index}.passport_expiration_date`} control={control} render={({ field }) => (
                                                <RHFCustomDatePicker value={field.value ?? ''} onChange={(val) => field.onChange(val)} maxYear={2099} />
                                            )} />
                                        </Input.Wrapper>
                                    </Grid.Col>
                                </Grid>


          <Title order={4} mt="xl">Address
              
              {index > 0 && (
  <Group mt="md">
    <RHFCheckbox
      control={control}
      name={`customers.${index}.sameAsPrevious`}
      label="Same as Previous Traveler Address"
    />
  </Group>
)}
             </Title>
                                <Divider my="sm" />
                                <Grid>
                                    <Grid.Col span={{ base: 12, md: 3 }}>
                                        <Input.Wrapper label="Address">
                                            <RHFGoogleAddress googleAddress={customerAddress?.label}  setGoogleAddress={(value) => {
    setValue(
      `customers.${index}.address`,
      value
    );
  }} isRequired={false} />
                                        </Input.Wrapper>
                                    </Grid.Col>
                                    <Grid.Col span={{ base: 12, md: 3 }}><RHFTextInput control={control} name={`customers.${index}.city`} label="City" withAsterisk rules={{ required: "Required" }} /></Grid.Col>



                                    <Grid.Col span={{ base: 12, md: 3 }}>
                                        <Input.Wrapper label="State" withAsterisk error={errors.state?.message}>
                                            <Controller name={`customers.${index}.state`} control={control} rules={{ required: "Required" }} render={({ field }) => (
                                                <RegionDropdown country={selectedCountry} style={selectStyle} defaultOptionLabel="- Select State -" value={field.value} onChange={(val) => field.onChange(val)} />
                                            )}
                                            />
                                        </Input.Wrapper>
                                    </Grid.Col>

                                    <Grid.Col span={{ base: 12, md: 3 }}><RHFTextInput control={control} name={`customers.${index}.zip`} label="Zip Code" withAsterisk rules={{ required: "Required" }} /></Grid.Col>

                                    <Grid.Col span={{ base: 12, md: 3 }}>
                                        <Input.Wrapper label="Country" withAsterisk error={errors.country?.message}>
                                            <Controller name={`customers.${index}.country`} control={control} rules={{ required: "Required" }} render={({ field }) => (
                                                <CountryDropdown style={selectStyle} defaultOptionLabel="- Select Country -" value={field.value} onChange={(val) => { field.onChange(val); setValue('state', ''); }} />
                                            )}
                                            />
                                        </Input.Wrapper>
                                    </Grid.Col>
                                </Grid>




                                <Title order={4} mt="xl">Cost and Options</Title>
                                <Divider my="sm" />




                                <Group mt="xl" >
                                    <RHFCheckbox mr='xl' control={control} name={`customers.${index}.options.fullPackage`} label={`Full Package ($${tourDetails?.full_package_price || 0})`} description='' />
                                    <RHFCheckbox mr='xl' control={control} name={`customers.${index}.options.accommodation`} label={`Accommodation Only ($${tourDetails?.accommodation_only_price || 0})`} description='' />
                                    <RHFCheckbox mr='xl' control={control} name={`customers.${index}.options.singleRoomCost`} label={`Private Room Cost ($${tourDetails?.single_room_cost || 0})`} description='' />
                                    <RHFCheckbox mr='xl' control={control} name={`customers.${index}.options.insurance`} label={`Travel Insurance ($${tourDetails?.insurance_price || 0})`} description='' />
                                    <RHFCheckbox mr='xl' control={control} name={`customers.${index}.options.otherCost`} label={`Other Cost ($${tourDetails?.other_cost || 0})`} description={tourDetails?.other_cost_description ? `(${tourDetails?.other_cost_description})` : ''} />
                                </Group>

                                <Input.Wrapper label="Special Ticket Arrangement (Not the group tickets)" size="md" mt={'xl'} mb="xl">
                                    <Group mt="lg" spacing="xl" gap={'lg'}>
                                        {ticketOptions.map((item) => (
                                            <Checkbox
                                                key={item.value}
                                                label={item.label}
                                                styles={{
                                                    label: {
                                                        fontSize: '15px'
                                                    }
                                                }}
                                                checked={watch(`customers.${index}.special_ticket_preference`) === item.value}
                                                onChange={() => {
                                                    const current = watch(`customers.${index}.special_ticket_preference`);
                                                    setValue(`customers.${index}.special_ticket_preference`, current === item.value ? "" : item.value);
                                                }}
                                                style={{ cursor: "pointer" }}
                                            />
                                        ))}
                                    </Group>
                                </Input.Wrapper>


                                <Paper p="md" withBorder bg="gray.0">
                                    <Title order={5}>Total Cost Summary</Title>
                                    <Text size="xl" style={{ fontWeight: 600 }} ml={'md'} weight={600} color="blue">${totalPrice.toFixed(2)}</Text>
                                    <Divider my="sm" />
                                    <Grid align="flex-end">
                                        {/* <Grid.Col span={{ base: 12, md: 3 }}>
                                            <RHFSelect control={control} name={`customers.${index}.payment_method`} label="Payment Method" data={tourDetails?.payment_methods?.length > 0 ? tourDetails?.payment_methods : ["Cash", "Card", "Check", "Zelle"]} />

                                        </Grid.Col> */}

                                        { hasCostOptions && (
                                            <>

                                                <Grid.Col span={{ base: 12, md: 3 }}>
                                                    <RHFCheckbox
                                                        control={control}
                                                        name={`customers.${index}.depositRequired`}

                                                        label={
                                                            <div className="deposit-text-stack">
                                                                <span className="deposit-title">
                                                                    Deposit {minimumDepositRequired ? '(Mandatory)' : ''}
                                                                </span>
                                                                <span className="deposit-subtitle">
                                                                    (Minimum ${minimumDeposit})
                                                                </span>
                                                            </div>
                                                        }
                                                    />


                                                </Grid.Col>
                                                <Grid.Col span={{ base: 12, md: 3 }}>
                                                    <Group align="flex-end" spacing="xs">
                                                        <RHFCheckbox control={control} name={`customers.${index}.enableExtraDeposit`} mb={10} />
                                                        <RHFNumberInput
                                                            control={control}
                                                            name={`customers.${index}.extraDepositAmount`}
                                                            label="Extra Payment"
                                                            allowNegative={false}
                                                            allowDecimal
                                                            disabled={!enableExtraDeposit}
                                                            leftSection={<FiDollarSign size={14} />}
                                                            placeholder="Amount"
                                                            rules={{
                                                                validate: (value) => !enableExtraDeposit || value > 0 || "Required"
                                                            }}
                                                        />
                                                    </Group>
                                                </Grid.Col>



                                            </>

                                        )}

                                        { hasCostOptions && <Grid.Col span={{ base: 12, md: 3 }}>


                                            <RHFTextInput
                                                control={control}
                                                name={`customers.${index}.advance_payment`}
                                                readOnly={paymentMethod === 'Card' ? true : false}
                                                label="Payment"
                                                // disabled={true}
                                                leftSection={<FiDollarSign size={14} />}
                                                placeholder="Amount"

                                            />

                                        </Grid.Col>}


                                    </Grid>


                                </Paper>


                            </div>
  )
}

export default CustomerForm